import React, {useLayoutEffect} from "react";
import _ from "lodash";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5locales_it_IT from "@amcharts/amcharts5/locales/it_IT"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import {addLicense, getXYChart, STATUS_COLORS} from "@components/Charts/commons";
import {LKP_STATUS} from "@utils/constants";


function NominationPersonaReportTrendChart({id, data, categories}) {

  useLayoutEffect(
    () => {

      if (!data)
        return

      addLicense();
      let root = am5.Root.new(id);
      root.setThemes([am5themes_Animated.new(root)])
      root.locale = am5locales_it_IT;
      root.numberFormatter.set("numberFormat", "#,###.");
      root.dateFormatter.set("dateFormat", "MMM yyyy")

      // Create chart
      let chart = getXYChart(root, {layout: root.verticalLayout})
      let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
      cursor.lineX.set("visible", false);
      cursor.lineY.set("visible", false);

      let legend = chart.children.unshift(
        am5.Legend.new(root, {
          centerX: am5.p50,
          x: am5.p50
        })
      );

      legend.markers.template.setAll({
        width: 10,
        height: 10
      });

      legend.labels.template.setAll({
        fontSize: 10,
        fontWeight: "300"
      });

      // Create axes
      // CategoryAxis: is the only axis type that requires its own data as well as data field set up.
      let xAxis = chart.xAxes.push(
        chart.xAxes.push(am5xy.DateAxis.new(root, {
            baseInterval: {timeUnit: 'month', count: 1},
            gridIntervals: [{timeUnit: "month", count: 1}],
            renderer: am5xy.AxisRendererX.new(root, {}),
          })
        ))
      xAxis.data.setAll(data);
      let xRenderer = xAxis.get("renderer");
      xRenderer.grid.template.set("forceHidden", true);
      xRenderer.labels.template.set("fontSize", 12);

      let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        min: 0,
        extraMax: 0.05,
        maxPrecision: 0,
        renderer: am5xy.AxisRendererY.new(root, {}),
        calculateTotals: true
      }))
      let yRenderer = yAxis.get("renderer");
      yRenderer.grid.template.set("forceHidden", true);
      yRenderer.labels.template.set("forceHidden", true);


      // Add series
      function makeSeries(name) {
        let series = chart.series.push(am5xy.ColumnSeries.new(root, {
          name: LKP_STATUS[name],
          xAxis: xAxis,
          yAxis: yAxis,
          fill: STATUS_COLORS[name],
          stroke: am5.color("rgb(255,255,255)"),
          valueYField: name,
          valueXField: "month",
          stacked: true,
          tooltip: name === 'total' ? null : am5.Tooltip.new(root, {
            labelText: "{valueX.formatDate()}\n[bold]{name}: {valueY} ({valueYTotalPercent}%)[/]",
            tooltipY: am5.percent(10),
            fontSize: 8
          })
        }))

        series.columns.template.setAll({
          fillOpacity: 0.65,
          visible: name !== 'total',
          cornerRadiusTL: 4,
          cornerRadiusTR: 4,
          cornerRadiusBL: 4,
          cornerRadiusBR: 4,
        });


        series.bullets.push(function () {
          return am5.Bullet.new(root, {
            locationY: 0.5,
            sprite: am5.Label.new(root, {
              text: name === 'total' ? "[bold]{valueYTotal}[/]" : "[bold]{valueY}[/]",
              centerX: am5.p50,
              centerY: name === 'total' ? am5.p100 : am5.p50,
              populateText: true,
              fontSize: name === 'total' ? 13 : 11
            })
          });
        });


        series.data.processor = am5.DataProcessor.new(root, {
          dateFields: ['month'],
          dateFormat: "yyyy-MM-dd"
        })

        legend.data.push(series);
        series.data.setAll(data);

        if (name === 'total') {
          series.get("legendDataItem").get("itemContainer").hide();
        }

        series.appear(1000);

        return series
      }

      categories.forEach(c => {
        makeSeries(c)
      })
      makeSeries('total')


      return () => {
        root.dispose()
      }
    },
    [id, data, categories] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return <div id={id} className={`w-full h-80`}/>
}

export default React.memo(NominationPersonaReportTrendChart, (props, nextProps) => {
  return _.isEqual(props.data, nextProps.data)
})
